import React from 'react'
import { Heading, Span } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

interface DefectNoticeInfoProps {
  defectNotice: {
    id: number
    title: string | null
  }
}

export const DefectNoticeInfo: React.FC<DefectNoticeInfoProps> = ({
  defectNotice,
}) => {
  const { t } = useTranslation(['common', 'defectNotice', 'titles'])

  if (!defectNotice) {
    return null
  }

  return (
    <>
      <Heading element="h4" size="s" className="phone:font-medium">
        {t('defectNotice:headings.editNotice')}
        <Span className="float-end">#{defectNotice.id}</Span>
      </Heading>
      <Heading
        element="h2"
        size="xl"
        className="whitespace-pre-wrap break-words phone:font-medium mt-6"
      >
        {defectNotice.title}
      </Heading>
    </>
  )
}
